

/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useState, Fragment } from 'react';
import MainHeader from "../../../../Shared/components/Header";
import customStyles from "../../../../../assets/styles/customStyles";
import { CustomForm } from './CustomForm';
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import crudActions from "../../../../CRUD/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { AESDecrypt } from "../../../../../helpers/Crypto";
import { toast } from 'react-toastify';
import { checkCRUDViewPermission } from "../../../../../helpers/utilities";
import ProductIcon from "../../../../../assets/images/icon_menus/ProductIcon.json";


const StockCountCreate = (props) => {
    const { readDetails, readError } = useSelector(state => state.crudReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const formRef = useRef('');
    const { history } = props;
    const dispatch = useDispatch();
    let { stockId } = useParams();
    const decryptedId = AESDecrypt(stockId);
    const [view, setView] = useState(false);
    const { type } = useParams();
    const prevReadDetails = usePrevious(readDetails);
    const [showDetails, setShowDetails] = useState(true);


    useEffect(() => {
        if (stockId !== undefined && decryptedId === 0) {
            history.push('/product/inventory/stock-count');
            return true;
        }
        if (roleManagement !== '' && checkCRUDViewPermission('Stock Count', type, history, 'Product')) {
            loadTask();
        }
        if (type === 'view') {
            setView(true);
        } else {
            setView(false);
        }
    }, [stockId, type, roleManagement]);


    const loadTask = () => {
        if (stockId) {
            dispatch({ type: crudActions.READ_DETAILS_START, id: decryptedId, url: "stockCount" });
        }
    }

    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            setShowDetails(false);
            if (type === 'view' || readDetails?.countStatus === 'CONFIRMED') {
                setView(true);
            } else {
                setView(false);
            }
            formRef.current.onEdit(readDetails);
        } else if (readError) {
            if (readError.error.statusCode) {
                toast.error('Stock Count ID is invalid');
                history.push('/product/inventory/stock-count');
            }
        }
    }, [readDetails, readError]); 

    const classes = customStyles();
    return (
        <Fragment>
            <MainHeader {...props} cls={'newImg'} img={ProductIcon} title={'Product'}
                links={[{ 'label': 'Product', 'link': '/product' }, { 'label': 'Stock Count', 'link': '' }]}
                closeLink={'/product/inventory/stock-count'}
            />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky, { [classes.scrollBorder]: type === 'create' ? true : !showDetails })}>
                <div id="containerDiv" className={clsx(classes.stickyContainer)}>
                    <CustomForm
                        ref={formRef}
                        showDetails={type === 'create' ? false : showDetails}
                        view={view}
                        stockId={stockId === undefined ? stockId : decryptedId}
                        type={type}
                        roleManagement={roleManagement}
                        loadTask={() => loadTask()}
                        classes={classes}
                        dispatch={dispatch}
                        clsx={clsx}
                        {...props}
                    />
                </div>
            </div>
        </Fragment>
    )
}

export default StockCountCreate